module.exports = __webpack_public_path__ + "img/under-maintenance.389e7733.svg";